import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { RefreshCw, MessageSquare } from "lucide-react";

export function ContactsPanel({ contacts, onRefresh }) {
  return (
    <div className="mt-8 bg-white border border-zinc-200">
      <div className="p-4 border-b border-zinc-200 flex items-center justify-between">
        <h2 className="font-semibold text-zinc-900">Contact Form Submissions</h2>
        <Button variant="ghost" size="sm" onClick={onRefresh}>
          <RefreshCw className="w-4 h-4 mr-1" /> Refresh
        </Button>
      </div>
      {contacts.length === 0 ? (
        <div className="p-8 text-center text-zinc-500">No contact submissions yet</div>
      ) : (
        <div className="divide-y divide-zinc-200">
          {contacts.map((contact) => (
            <div key={contact.contact_id} className="p-4">
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-zinc-900">{contact.name}</span>
                    <Badge variant="outline">{contact.subject}</Badge>
                  </div>
                  <p className="text-sm text-zinc-500">{contact.email}</p>
                  {contact.order_id && <p className="text-xs text-zinc-400">Order: {contact.order_id}</p>}
                </div>
                <span className="text-xs text-zinc-400">{new Date(contact.created_at).toLocaleDateString()}</span>
              </div>
              <p className="mt-2 text-sm text-zinc-700 bg-zinc-50 p-2 rounded">{contact.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
